module.exports = __webpack_public_path__ + "static/media/EllipseDot.521b3e09.svg";